import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import PageLayout from "../../Components/UI/PageLayout.js";
import { siteUpdates } from "../../Data/siteUpdates.js";

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const UpdatesPage = () => {
  return (
    <PageLayout
      title="Site Updates"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Site Updates" }]}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {siteUpdates.map((update) => (
          <Card key={update.date} sx={{ backgroundColor: "#2a3447" }}>
            <CardContent sx={{ p: 3 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}
              >
                <Chip
                  label={formatDate(update.date)}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {update.title}
                </Typography>
              </Box>
              <Typography variant="body1" color="text.secondary">
                {update.body}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </PageLayout>
  );
};

export default UpdatesPage;
